import "./Footer.css" ;
function Footer() {
    return (
      <>
        <div className="footer">
          <div className="footer-sec1">
            <div>
              <img src="/Images/UnionWhite.png" alt="UnionWhite" />
              <p>World's leading chain of hotels and homes</p>
            </div>
            <div>
              <p>Join our network and grow your business!</p>
              <button>
                <img src="/Images/property.png" alt="property" />
                List your property
              </button>
            </div>
          </div>
          <div className="footer-sec2">
            <div>
              <p>Download OYO app for excitng offers.</p>
              <br />
              <img src="/Images/appstore.png" alt="applestore" />
  
              <img src="/Images/playstored.png" alt="playstored" />
            </div>
            <div>
              <p>About Us</p>
              <p>Official OYO Blog</p>
              <p>Teams/Careers</p>
              <p>Investor Relations</p>
              <p>Blogs</p>
              <p>OYO Circle</p>
              <p>Support</p>
              <p>OYO Frames</p>
            </div>
            <div>
              <p>Terms and conditions</p>
              <p>Guest Policies</p>
              <p>Privacy Policy</p>
              <p>Responsible Disclosure</p>
            </div>
          </div>
          {/* <div className="footer-sec3">
            <div>
              <h3>OYO Townhouse</h3>
              <p>Your Frendly Neighbourhood Hotel</p>
            </div>
            <div>
              <h3>OYO SilverKey</h3>
              <p>Executive Stays</p>
            </div>
            <div>
              <h3>OYO HOME</h3>
              <p>Unlocking Homes</p>
            </div>
          </div> */}
          <div className="footer-sec4">
            <h2>OYO Hotels</h2>
            <div className="footer-sec4-flex">
              <div>
                <p>Hotels near me</p>
                <p>Hotels in Manali</p>
                <p>Hotels in Nainital</p>
                <p>Hotels in Mount Abu</p>
                <p>Hotels in Agra</p>
                <p>Hotels in Harigwar</p>
                <p>Hotels in Gurgaon</p>
                <p>Hotels in Coimbatore</p>
                <p>OYO Hotel UK</p>
              </div>
              <div>
                <p>Hotels in Goa</p>
                <p>Hotels in Udaipur</p>
                <p>Hotels in Lonavala</p>
                <p>Hotels in Kodaikanal</p>
                <p>Hotels in Gangtok</p>
                <p>Hotels in Kolkata</p>
                <p>Hotels in Mandarmoni</p>
                <p>Hotels in Kasauli</p>
                <p>OYO Hotel US</p>
              </div>
              <div>
                <p>Hotels in Puri</p>
                <p>Hotels in Mussoorie</p>
                <p>Hotels in Munnar</p>
                <p>Hotels in Hyderabad</p>
                <p>Hotels in Coorg</p>
                <p>Hotels in Ahmedabad</p>
                <p>Hotels in Daman</p>
                <p>Hotels in Dehradun</p>
                <p>OYO Hotel Mexico</p>
              </div>
              <div>
                <p>Hotels in Mahabaleshwar</p>
                <p>Hotels in Pondicherry</p>
                <p>Hotels in Bangalore</p>
                <p>Hotels in Pune</p>
                <p>Hotels in Chennai</p>
                <p>Hotels in Shillong</p>
                <p>Hotels in Yercaud</p>
                <p>Travel Guide</p>
                <p>OYO Hotel Brasil</p>
              </div>
              <div>
                <p>Hotels in Jaipur</p>
                <p>Hotels in Delhi</p>
                <p>Hotels in Mysore</p>
                <p>Hotels in Chandigarh</p>
                <p>Hotels in Tirupati</p>
                <p>Hotels in Rishikesh</p>
                <p>Hotels in Amritsar</p>
                <p>All cities Hotels</p>
                <p>OYO Hotel China</p>
              </div>
              <div>
                <p>Hotels in Shimla</p>
                <p>Hotels in Mumbai</p>
                <p>Hotels in Darjeeling</p>
                <p>Hotels in Shirdi</p>
                <p>Hotels in Dalhousie</p>
                <p>Hotels in Varanasi</p>
                <p>Hotels in Madurai</p>
                <p>Coupons</p>
                <p>OYO Hotel Indonesia</p>
              </div>
            </div>
          </div>
          <div className="footer-sec5">
            <div>
              <img src="/Images/facebookIcon.png" alt="img" />
              <img src="/Images/InstagramIcon.png" alt="img" />
              <img src="/Images/TwitterIcon.png" alt="img" />
              <img src="/Images/MediaIcon.png" alt="img" />
              <img src="/Images/PinIcon.png" alt="img" />
            </div>
            <div>
              <p>2013-2021 © Oravel Stays Private Limited</p>
            </div>
          </div>
        </div>
      </>
    );
  }
  
  export default Footer;
  